import "./contact-us.scss";
import Grid from '@material-ui/core/Grid';
import {TwitterCircleFilled,FacebookFilled} from "@ant-design/icons";
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';

import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import MenuItem from '@material-ui/core/MenuItem';




const ContactUs = () => {

  return(
  <div className="contact-us-container">

        <div className="contact-us-happy">
            <h2>يسعدنا <span className="shawi-font-color">تواصلكم معنا</span></h2>
            <p>إذا كان لديكم أي استفسارات يمكنكم ملء هذا النموذج التالي وسنتواصل معكم في أقرب وقت ممكن </p>
        </div>

      <Grid container>
        <Grid item xs={4}>
          <div className="contact-us-data-info">
              
                    <h2 className="contact-us-headline">تواصل <span className="shawi-font-color">معنا من خلال</span>  </h2>  
                        <div className="contact-us-location"> 
                         <a href="https://goo.gl/maps/adZEiLbjwMtAjmoAA" target="_blank"> <span href="https://goo.gl/maps/adZEiLbjwMtAjmoAA" target="_blank"><MapOutlinedIcon/> الرياض-حي الريان مخرج14-شارع عنيزة متقاطع مع  شارع أحمد بن حنبل مقابل لمستشفى رعاية (شمالا) </span></a>
                        </div>
                       <div className="call-mail">
                          <ul>
                            <li> <a href="tel:+966114913115" target="_blank"><span href="tel:+966114913115" target="_blank"> <CallOutlinedIcon/>0114913115 </span></a>   </li>
                            <li> <a href="mailto:info@msalshawi.com"  target="_blank"><span href="mailto:info@msalshawi.com"  target="_blank"><MailOutlinedIcon/> info@msalshawi.com </span> </a> </li>
                          </ul>
                       </div>
            </div>
          {/*
            <div className="map-contact">
                       <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3624.689354408845!2d46.7762369!3d24.7032033!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f06d2f776d9a9%3A0x4697d5e4f7e3972c!2sSheikh%20Muhammed%20Salih%20Al-Shawi%20Foundation!5e0!3m2!1sen!2seg!4v1611479906779!5m2!1sen!2seg" width="750px" height="400" frameborder="0" className="map-iframe-contact" style={{borderRadius:20}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
             </div>

             */}
             
    
        </Grid>

        <Grid item xs={8}>
            <div className="contact-us-data-form">
              <form className="form-width" noValidate>
                <Grid container  spacing={2}>
                    <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="name"
                                  label="الاسم   "
                                  name="name"
                                  type="text"
                                  // autoComplete="name"
                              />
                          </Grid>

                    <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="email"
                                  label="عنوان البريد الإلكتروني "
                                  name="email"
                                  type="email"
                                  // autoComplete="email"
                              />
                          </Grid>
                      <Grid item xs={12} sm={6}>
                          <TextField
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="applicantPhoneNumber"
                              label="رقم الجوال "
                              name="applicantPhoneNumber"
                              type="tel"
                              // autoComplete="phoneNumber"
                          />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="address"
                                  label="العنوان   "
                                  name="address"
                                  type="text"
                              />
                          </Grid>

                    <Grid item xs={12} sm={12}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  fullWidth
                                  id="subject"
                                  label="الموضوع  "
                                  name="subject"
                                  type="text"
                              />
                          </Grid>   
                          
                          
                      <Grid item xs={12} sm={12}>
                              <TextField
                                  variant="outlined"
                                  margin="normal"
                                  required
                                  multiline
                                  fullWidth
                                  id="message"
                                  rows={12}
                                  label="يرجى كتابة رسالتك أو أستفسارك ...  "
                                  name="message"
                                  type="message"
                                  
                              />
                          </Grid> 


                
                </Grid>
                <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
            >
            إرسال   
          </Button>
              </form>
          
            </div>
        </Grid>
      </Grid>
       
  </div>
  );
};

export default ContactUs;
